import { create, type StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

const isDev = process.env.NODE_ENV === 'development';

export function createWithDevtools<T extends object>(initializer: StateCreator<T>, name: string) {
  if (isDev) {
    return create<T>()(
      devtools(initializer, {
        name,
        enabled: true,
      }),
    );
  }

  return create<T>(initializer);
}
